import React, { Suspense, lazy } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import styled from "styled-components";
import GlobalStyles from "./styles/GlobalStyles";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";

// Eagerly loaded — these are the most common landing pages
import Home from "./pages/Home";
import About from "./pages/About";

// Lazy loaded — deferred until the route is visited
const Work = lazy(() => import("./pages/Work"));
const Blog = lazy(() => import("./pages/Blog"));
const Resume = lazy(() => import("./pages/Resume"));
const Contact = lazy(() => import("./pages/Contact"));
const CaseStudyDetail = lazy(() => import("./pages/CaseStudyDetail"));
const BlogPostDetail = lazy(() => import("./pages/BlogPostDetail"));
const Media = lazy(() => import("./pages/Media"));
const Consulting = lazy(() => import("./pages/Consulting"));
const NotFound404 = lazy(() => import("./pages/NotFound404"));

function App() {
  return (
    <Router>
      <ScrollToTop />
      <GlobalStyles />
      <a href="#main-content" className="skip-link">Skip to content</a>
      <Wrapper>
        <Navbar />
        <main id="main-content">
          <Suspense fallback={<PageLoader />}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/work" element={<Work />} />
              <Route path="/work/:slug" element={<CaseStudyDetail />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:slug" element={<BlogPostDetail />} />
              <Route path="/media" element={<Media />} />
              <Route path="/resume" element={<Resume />} />
              <Route path="/consulting" element={<Consulting />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="*" element={<NotFound404 />} />
            </Routes>
          </Suspense>
        </main>
        <Footer />
      </Wrapper>
    </Router>
  );
}

function PageLoader() {
  return <LoaderWrap aria-label="Loading page" />;
}

const Wrapper = styled.div`
  min-height: 100vh;
  background-color: #fff;
  display: flex;
  flex-direction: column;

  main {
    flex: 1;
  }
`;

const LoaderWrap = styled.div`
  min-height: 60vh;
`;

export default App;
